/* istanbul ignore file */
export * from './useAddLastSeen';
